import { useRouter } from 'vue-router';

import type { ApiTabValueType } from './types';

export default function useApiRoutes() {
  const router = useRouter();

  function openTab(tab: ApiTabValueType) {
    return router.push({ name: 'api', params: { tab } });
  }

  function openCreate(tab: ApiTabValueType) {
    return router.push({ name: 'api_create', params: { tab } });
  }

  function openDetail(tab: ApiTabValueType, id: string) {
    return router.push({ name: 'api_detail', params: { tab, id } });
  }

  return { openTab, openCreate, openDetail };
}
